/* eslint-disable react/react-in-jsx-scope */
import { hslaToHsva, hsvaToHex, type HslColor } from "@uiw/react-color";
import Chrome from "@uiw/react-color-chrome";
import { GithubPlacement } from "@uiw/react-color-github";
import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";
export const ColorPicker = ({
  color,
  onColorChange,
}: {
  color: HslColor;
  onColorChange: (newColor: string) => void;
}) => {
  const defaulthsva = hslaToHsva({
    ...color,
    a: 1,
  });
  const [hsva, setHsva] = useState(defaulthsva);
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          className="size-6 flex-shrink-0 rounded border"
          style={{
            backgroundColor: hsvaToHex(hsva),
          }}
        ></button>
      </PopoverTrigger>
      <PopoverContent className="isolate z-[999999]">
        <Chrome
          color={hsva}
          style={{ float: "left" }}
          placement={GithubPlacement.Right}
          onChange={(color) => {
            setHsva(color.hsva);
            onColorChange(
              `${color.hsla.h}, ${color.hsla.s}%, ${color.hsla.l}%`
            );
          }}
        />
      </PopoverContent>
    </Popover>
  );
};
